<template>
  <v-card>
    <v-card-title>비밀번호 변경</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col>
              <h2>로그인 ID : {{ item.loginId }}</h2>
            </v-col>
            <v-col>
              <h2>이름 : {{ item.name }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="newPassword.oldPassword"
                :rules="notEmptyValidation"
                label="현재 비밀번호"
                type="password"
                required/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="newPassword.newPassword"
                :rules="notEmptyValidation"
                label="새 비밀번호"
                type="password"
                required/>
            </v-col>
            <v-col>
              <v-text-field
                v-model="newPassword.passwordRepeat"
                :rules="passwordRepeatValidation"
                label="비밀번호 확인"
                type="password"
                required/>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn text color="error" @click="updatePassword(newPassword)">확인</v-btn>
      <v-btn text @click="dialog.updatePasswordDialog = false">취소</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'updateMyAccountPasswordDialog',
    props: {
      item: {
        type: Object,
        required: true
      },
      dialog: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        newPassword: {
          oldPassword: '',
          newPassword: '',
          passwordRepeat: ''
        },
        notEmptyValidation: [
          value => !!value || '필수 값입니다'
        ],
        passwordRepeatValidation: [
          value => !!value || '필수 값입니다',
          value => value === this.newPassword.newPassword || '패스워드값과 패스워드 확인값이 서로 다릅니다.'
        ],
      }
    },
    methods: {
      updatePassword(newPassword) {
        const retryFuncBackup = this.updatePassword.bind(this, newPassword);

        if (!this.$refs.form.validate()) {
          return;
        }

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/users/_self/_password`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        axios.put(targetUri, newPassword, config)
          .then(result => {
            this.popupAlert('비밀번호 변경 성공', 'green');
            this.dialog.updatePasswordDialog = false;
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401) {
              if ("TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
                this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
                return;
              }

              if ("CURRENT_PASSWORD_IS_INVALID" === error.response.data.detailedErrorCode) {
                console.error(error.response);
                this.popupAlert('현재 비밀번호가 잘못되었습니다.', 'red');
                return;
              }
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
            this.dialog.updatePasswordDialog = false;
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      },
    },
  }
</script>